import { render } from "./ShowPolicy.vue?vue&type=template&id=ee433252&scoped=true"
import script from "./ShowPolicy.vue?vue&type=script&lang=js"
export * from "./ShowPolicy.vue?vue&type=script&lang=js"

import "./ShowPolicy.vue?vue&type=style&index=0&id=ee433252&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee433252"]])

export default __exports__